import React, { useEffect, useRef, useState } from "react"
import { Text } from "~/ui/primitives"
import { Camera, useCameraDevice, useCodeScanner } from "~/ui/vision-camera"
// import { launchImageLibrary } from "react-native-image-picker"
import Toast from "~/ui/toast"
// import Icon from "~widgets/icon"
import styled from '~/ui/styled'

const Container = styled.View`
  flex: 1;
  position: relative;
`

// const Button = styled.TouchableOpacity`
//   position: absolute;
//   right: 15px;
//   bottom: 60px;
//   width: 40px;
//   height: 40px;
//   border-radius: 20px;
//   background-color: #07c160;
//   align-items: center;
//   justify-content: center;
// `

const PendingView = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
`

const QrcodeScanner = ({ onScan }) => {
  const [hasPermission, setHasPermission] = useState(false)
  const device = useCameraDevice("back")
  const toast = useRef(null)
  const onScanRef = useRef(onScan)
  const lastScanRef = useRef<{ value: string; at: number } | null>(null)

  useEffect(() => {
    onScanRef.current = onScan
  }, [onScan])

  useEffect(() => {
    ;(async () => {
      const cameraPermission = await Camera.requestCameraPermission()
      setHasPermission(cameraPermission === "granted")
    })()
  }, [])

  const codeScanner = useCodeScanner({
    codeTypes: ["qr", "ean-13"],
    onCodeScanned: (codes) => {
      // console.log(codes, '--codes--')
      const raw = codes[0]?.value
      if (!raw) return
      const now = Date.now()
      const prev = lastScanRef.current
      if (prev && prev.value === raw && now - prev.at < 2000) return
      lastScanRef.current = { value: raw, at: now }
      onScanRef.current?.(raw)
    },
  })

  // const selectImage = () => {
  //   launchImageLibrary({ mediaType: "photo", includeBase64: true }, async (response) => {
  //     const base64 = response.assets?.[0]?.base64
  //     if (!base64) return
  //   })
  // }

  if (!device) {
    return (
      <PendingView>
        <Text>等待摄像头设备加载...</Text>
      </PendingView>
    )
  }

  if (!hasPermission) {
    return (
      <PendingView>
        <Text>等待摄像头权限授权...</Text>
      </PendingView>
    )
  }

  return (
    <Container>
      <Camera
        style={{ flex: 1 }}
        device={device}
        isActive={true}
        codeScanner={codeScanner}
      />
      {/* <Button onClick={selectImage}>
        <Icon name={"camerao"} color={"#fff"} size={20} />
      </Button> */}
      <Toast ref={toast} position={"center"} />
    </Container>
  )
}

export default QrcodeScanner
